import templateUrl from 'emun.shopping/shopping-quick-view.htm'
import modals from 'webmodals/modals'

export default (product, options) => modals.open(Object.assign({
    size: 'fullscreen',
    templateUrl,
    bindToController: true,
    controller() {
        this.product = product;
		this.productId = product.id || product;
        this.container = options && (options.container || options.shoppingContainer);
        console.debug('shopping quick view', this, {product, options});
    },
    controllerAs: '$ctrl'
}, (options || {}).modal)).result;